import styled from 'styled-components';
import { desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

export const VariantItemsWrapper = styled.div`
  width: 100%;

  ${desktop1024`
    margin-left: 0;
    margin-right: 0;
    justify-content: space-between;
  `}

`;

VariantItemsWrapper.disable = 'VariantItemsWrapper';
